import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { MailOpen, X } from "lucide-react";
import { useLang } from "../context/LanguageContext";

const KEY = "gg_invite_dismissed";

export default function InviteTeaser() {
  const { t } = useLang();
  const navigate = useNavigate();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(KEY)) return;
    const timer = setTimeout(() => setShow(true), 9000);
    return () => clearTimeout(timer);
  }, []);

  const dismiss = () => {
    localStorage.setItem(KEY, "1");
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="invite-teaser"
          className="fixed bottom-5 right-5 z-[115] w-[330px] max-w-[calc(100vw-40px)] border border-brass/40 bg-surface2/95 backdrop-blur p-6 shadow-2xl"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        >
          <button
            data-testid="invite-teaser-close"
            onClick={dismiss}
            aria-label="Chiudi invito"
            className="absolute top-3 right-3 text-stone hover:text-brass transition-colors duration-300 p-1"
          >
            <X size={16} strokeWidth={1.5} />
          </button>
          <MailOpen size={24} strokeWidth={1.1} className="text-brass" />
          <p className="mt-4 font-serif text-xl text-cream">{t.teaser.title}</p>
          <p className="mt-2 text-stone text-sm font-light leading-relaxed">{t.teaser.text}</p>
          <div className="mt-5 flex items-center gap-4">
            <button
              data-testid="invite-teaser-open"
              onClick={() => navigate("/invito")}
              className="inline-flex items-center gap-2 bg-brass text-ink text-[11px] uppercase tracking-[0.14em] font-semibold rounded-full px-5 py-2.5 hover:bg-cream transition-colors duration-400"
            >
              {t.teaser.open}
            </button>
            <button
              onClick={dismiss}
              className="text-[12px] text-stone/70 hover:text-stone transition-colors duration-300"
            >
              {t.teaser.dismiss}
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
